import { useMemo } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import useMediaQuery from '@/hooks/useMediaQuery.hook';

import { MediaQueriesEnum } from '@/enums/mediaQueries.enum';
import { RoutesEnum } from '@/enums/routes.enum';

import { addIdToRoute } from '@/routes/types';

export const useSettings = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const [isMobile, isTablet, isDesktop] = useMediaQuery([
    MediaQueriesEnum.isMobile,
    MediaQueriesEnum.isTablet,
    MediaQueriesEnum.isDesktop,
  ]);

  const pagesWithBackButton = useMemo(
    () =>
      [
        RoutesEnum.game,
        RoutesEnum.rules,
        addIdToRoute(RoutesEnum.contestRules, id),
        RoutesEnum.help,
      ].includes(pathname as RoutesEnum),
    [id, pathname],
  );

  return { isMobile, isTablet, isDesktop, pagesWithBackButton };
};
